module.exports = __webpack_public_path__ + "img/vpn-7.50bc7f68.jpg";